import React from 'react'
import Section from '../../../Section/Section'
import EssayReviewListCard from 'shared/components/EssayReviewListCard/EssayReviewListCard'
import s from './EssayListBlock.module.scss'

const EssayListBlock = ({
	title = 'Essay List',
	items = [],
	activeEssayId = null,
	onSelect = () => {},
	type = 'list',
	showVersionsCount = true,
}) => {
	const ListEssay = () => (
		<ul className={s.list}>
			{items.map((item, i) => {
				const active = String(item?.id || '') === String(activeEssayId || '')
				return (
					<li key={item.id || i}>
						<EssayReviewListCard
							{...item}
							showVersionsCount={showVersionsCount}
							active={active}
							unreadFeedbackCount={
								item.unreadFeedbackCount ?? item.unreadStudentQuestions ?? 0
							}
							onClick={() => onSelect(item)}
						/>
					</li>
				)
			})}
		</ul>
	)

	return type === 'list' ? (
		<ListEssay />
	) : (
		<Section title={title}>
			<ListEssay />
		</Section>
	)
}

export default EssayListBlock
